<template>
  <div class="main-layout__box">
    <div
      class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p14"
    >
      <div class="w-3 t-c foz-25">#</div>
      <div class="w-5">{{ $t("listsHeader.image") }}</div>
      <div class="w-15 main-flex">
        {{ $t("listsHeader.title") }}
        <div class="main-layout__sort-box">
          <sort-svg
            @onClick="sort('originalName', 'asc')"
            ref="originalName_asc"
            class="sort-svg sort-svg_up"
          />
          <sort-svg
            @onClick="sort('originalName', 'desc')"
            ref="originalName_desc"
            class="sort-svg"
          />
        </div>
      </div>
      <div class="w-10 main-flex">
        SKU
        <div class="main-layout__sort-box">
          <sort-svg
            @onClick="sort('shortName', 'asc')"
            ref="shortName_asc"
            class="sort-svg sort-svg_up"
          />
          <sort-svg
            @onClick="sort('shortName', 'desc')"
            ref="shortName_desc"
            class="sort-svg"
          />
        </div>
      </div>
      <div class="w-15 main-flex">
        {{ $t("listsHeader.price") }}
        <div class="main-layout__sort-box">
          <sort-svg
            @onClick="sort('price', 'asc')"
            ref="price_asc"
            class="sort-svg sort-svg_up"
          />
          <sort-svg
            @onClick="sort('price', 'desc')"
            ref="price_desc"
            class="sort-svg"
          />
        </div>
      </div>

      <div
        v-if="$guard('write', 'Materials') || $guard('delete', 'Materials')"
        class="main-layout__actions"
      >
        {{ $t("listsHeader.actions") }}
      </div>
    </div>

    <!--materials list start-->
    <div class="main-layout__list main-layout__list_mxh70" @scroll="scroll">
      <!--materials list item start-->
      <div
        class="main-layout__item main-layout__item_hover"
        v-for="(item, index) in list"
        :key="index"
        :class="{
          delete: item.deletion_tag,
        }"
      >
        <div class="w-3 t-c">{{ index + 1 }}</div>
        <div class="w-5 main-layout__item-image">
          <img :src="item.icon.path" alt />
        </div>
        <div class="w-15">
          <span>{{ item.name.original }}</span>
        </div>
        <div class="w-10">
          <span>{{ item.name.short }}</span>
        </div>
        <div class="w-15">
          <span>€</span>
          <span>{{ item.price | round }}</span>
        </div>

        <div class="main-layout__item-actions">
          <div
            v-if="$guard('write', 'Materials')"
            class="materials-list-button"
            @click="toggleAddModal('edit', item.id)"
          >
            <svg class="main-layout__item-icon">
              <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
            </svg>
          </div>
          <div class="materials-list-button" @click="openDeleteModal(item.id)">
            <svg class="main-layout__item-icon">
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>

          <delete-request
            v-if="$guard('delete', 'Materials') && item.deletion_tag"
            :item="item"
            :type="'materials'"
            @save="fetchMaterials"
            @remove="openDeleteModal"
          />
        </div>
      </div>
      <!--materials list item end-->
    </div>
    <!-- <div v-else>
        <p>{{$t('lists.listEmpty')}}</p>
    </div>-->
    <!--materials list end-->

    <!-- materials top end-->
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import deleteRequest from '@/components/controls/deleteRequest'
import sortSvg from '@/components/controls/sortSvg'
import sort from '@/mixins/sort'

export default {
    props: ['showList', 'list', 'id'],
    components: {
        deleteRequest,
        sortSvg,
    },
    mixins: [sort],
    methods: {
        ...mapActions({
            fetch: 'materials/fetch',
            prepareEditModal: 'materials/prepareEditModal',
            initServiceData: 'getServiceData',
            fetchMaterialIcons: 'materials/fetchMaterialIcons',
        }),
        ...mapMutations({
            toggleDeleteModal: 'materials/toggleDeleteModal',
            setDeleteId: 'materials/setDeleteId',
            updateModalType: 'materials/updateModalType',
            toggleModal: 'materials/toggleModal',
        }),
        toggleAddModal(type, id) {
            this.materialId = id
            this.$emit('clearErrors')
            if (type === 'edit') {
                this.loadEditModal(id)
                this.updateModalType('edit')
            } else this.updateModalType('add')
            this.toggleModal()
        },
        openDeleteModal(id = null) {
            this.setDeleteId(id)
            this.toggleDeleteModal()
        },
        async sort(orderBy, sortBy) {
            const isChanged = this.markSvgsComponents(`${orderBy}_${sortBy}`)

            this.orderBy = isChanged ? orderBy : null
            this.sortBy = isChanged ? sortBy : null

            await this.fetch({
                id: this.id,
                orderBy: this.orderBy,
                sortBy: this.sortBy,
                page: 'materials',
            })
        },
        async scroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            let isScrolled = false
            if (
                Math.round(scrollTop + clientHeight) >= scrollHeight
        && isScrolled === false
            ) {
                await this.fetch({
                    id: this.id,
                    limit: 20,
                    orderBy: this.orderBy,
                    sortBy: this.sortBy,
                })
                isScrolled = !isScrolled
                setTimeout(() => {
                    isScrolled = !isScrolled
                }, 1500)
            }
        },
        loadEditModal(id) {
            this.prepareEditModal(id)
        },
        async fetchMaterials() {
            await this.fetch({ id: this.id, page: 'materials' })
        },
    },
}
</script>
